import { FormControl, FormHelperText, TextField } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, get } from 'react-hook-form'
import DatePicker from '@mui/lab/DatePicker'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import 'date-fns'

export const ControlledDatePicker = ({
  name,
  defaultValue = '',
  label,
  helperText,
  ...rest
}) => {
  const { control, formState } = useFormContext()
  const error = get(formState.errors, name)
  const hasError = error !== undefined

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl fullWidth>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { onChange, value, ref } }) => (
            <DatePicker
              margin='none'
              id={`datepicker-${name}`}
              label={label}
              format='MM/dd/yyyy'
              value={value}
              onChange={onChange}
              inputVariant='outlined'
              InputLabelProps={{
                shrink: value !== '' && value !== undefined
              }}
              inputRef={ref}
              autoOk
              size='small'
              error={hasError ?? false}
              inputProps={{ readOnly: true }}
              renderInput={props => (
                <TextField
                  {...props}
                  variant='outlined'
                  size='small'
                  error={hasError}
                />
              )}
              KeyboardButtonProps={{
                'aria-label': 'change date',
                size: 'small'
              }}
              {...rest}
            />
          )}
        />
        {helperText !== undefined && !hasError && (
          <FormHelperText id={`helper-text-${name}`}>
            {helperText}
          </FormHelperText>
        )}
        {error?.message !== undefined && (
          <FormHelperText
            id={`error-helper-text-${name}`}
            error
            style={{ textAlign: 'right', paddingRight: 8 }}
          >
            {error?.message}
          </FormHelperText>
        )}
      </FormControl>
    </LocalizationProvider>
  )
}
